// v2/hooks/useAdminUsers.js — yonetim: kullanici listesi + giris kayitlari
import { useCallback, useEffect, useRef, useState } from 'react';
import { apiGet, qs } from '../utils/api';

function duzenle(veri) {
  return {
    ...veri,
    items: Array.isArray(veri.items) ? veri.items : [],
    summary: veri.summary || {},
    series: Array.isArray(veri.series) ? veri.series : [],
  };
}

/** /api/v2/admin/users/ */
export function useAdminUsers(params) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tetik, setTetik] = useState(0);
  const abortRef = useRef(null);
  const sorgu = qs(params);

  const yenile = useCallback(() => setTetik((n) => n + 1), []);

  useEffect(() => {
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;
    setLoading(true);
    setError(null);
    apiGet(`/v2/admin/users/${sorgu}`, { signal: ctrl.signal })
      .then((veri) => {
        if (ctrl.signal.aborted) return;
        if (!veri || !veri.success) throw new Error((veri && veri.message) || 'Liste alınamadı');
        setData(duzenle(veri));
      })
      .catch((e) => {
        if (ctrl.signal.aborted || (e && e.name === 'AbortError')) return;
        setError((e && e.message) || 'Liste alınamadı');
      })
      .finally(() => { if (!ctrl.signal.aborted) setLoading(false); });
    return () => ctrl.abort();
  }, [sorgu, tetik]);

  return { data, loading, error, yenile };
}

/** /api/v2/admin/logins/ */
export function useAdminLogins(params) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tetik, setTetik] = useState(0);
  const abortRef = useRef(null);
  const sorgu = qs(params);

  const yenile = useCallback(() => setTetik((n) => n + 1), []);

  useEffect(() => {
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;
    setLoading(true);
    setError(null);
    apiGet(`/v2/admin/logins/${sorgu}`, { signal: ctrl.signal })
      .then((veri) => {
        if (ctrl.signal.aborted) return;
        if (!veri || !veri.success) throw new Error((veri && veri.message) || 'Liste alınamadı');
        setData(duzenle(veri));
      })
      .catch((e) => {
        if (ctrl.signal.aborted || (e && e.name === 'AbortError')) return;
        setError((e && e.message) || 'Liste alınamadı');
      })
      .finally(() => { if (!ctrl.signal.aborted) setLoading(false); });
    return () => ctrl.abort();
  }, [sorgu, tetik]);

  return { data, loading, error, yenile };
}

export default useAdminUsers;
